import { ThemeModule } from "../../front/lib/ThemeModule";
export class SliderCards extends ThemeModule {
    constructor() {
        super(...arguments);
        this.sliderRootEl = this.getElementById('slider');
        this.swiper = null;
        this.drapeStartEl = this.querySelector('.swiper-drape.for--start');
        this.drapeEndEl = this.querySelector('.swiper-drape.for--end');
    }
    async init() {
        if (this.sliderRootEl) {
            const { Swiper, Scrollbar, Navigation } = (await import('swiper'));
            this.swiper = new Swiper(this.sliderRootEl, {
                modules: [Scrollbar, Navigation],
                slidesPerView: 'auto',
                spaceBetween: 15,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    dragSize: 75,
                    draggable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
            if (this.drapeStartEl && this.drapeEndEl) {
                this.swiper.on('progress', (swiper, progress) => {
                    var _a, _b, _c, _d;
                    if (progress === 1) {
                        (_a = this.drapeEndEl) === null || _a === void 0 ? void 0 : _a.classList.add('is--hidden');
                    }
                    else {
                        (_b = this.drapeEndEl) === null || _b === void 0 ? void 0 : _b.classList.remove('is--hidden');
                    }
                    if (!progress) {
                        (_c = this.drapeStartEl) === null || _c === void 0 ? void 0 : _c.classList.add('is--hidden');
                    }
                    else {
                        (_d = this.drapeStartEl) === null || _d === void 0 ? void 0 : _d.classList.remove('is--hidden');
                    }
                });
            }
        }
    }
    beforeDestroy() {
        var _a;
        (_a = this.swiper) === null || _a === void 0 ? void 0 : _a.destroy();
        super.beforeDestroy();
    }
}
